import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CustomerInterface } from 'app/models/customer.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { CustomerDataTransformPost } from './data-transforms/customer.data.transform.post';
import { CustomerDataTransformGet } from './data-transforms/customer.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class CustomerHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/customers(\/[0-9a-z]{24})?$/);

  constructor(
    private readonly _transformDown: CustomerDataTransformPost,
    private readonly _transformUp: CustomerDataTransformGet,
  ) {}

  intercept(req: HttpRequest<CustomerInterface>, next: HttpHandler): Observable<HttpEvent<CustomerInterface>> {
    return RequestService.getTransformedHttpEvent<CustomerInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
